// B3 — turning a chat reply's closing_id citations into clickable links into the Centro de
// Control, deterministically rather than trusting the model to format them.
//
// The analista_cierres agent is instructed (mantis, chat/instructions.js) to cite the closing_id
// behind every claim, but only as plain text — nothing asks it to produce a markdown link, and it
// would be the wrong place to ask: locked decision #4's whole point is that mechanical
// transformations belong in code, not in what the model is trusted to get right on every turn.
// So this finds a closing_id (a uuid) anywhere in the reply text and wraps it in a markdown link
// itself. BusinessAssistant.jsx already renders every assistant message through <ReactMarkdown>,
// so a `[text](url)` here becomes a clickable link with no other change needed there beyond a
// custom `a` renderer for the SPA-navigation half (see that file).
//
// Pure and pattern-only, deliberately: it does not know which businesses are on the chat agent or
// which messages came from it. For every tenant whose replies never contain a uuid — everyone but
// Brinks today — this is a no-op, which is what keeps their chat byte-identical.

const CONTROL_PANEL_PATH = "/business/backoffice/control-panel";

// BusinessExtraction.jsx's own deep-link matcher accepts this shape for `?id=` (B3 also taught it
// to match a row's closing_id, not only its main_key).
const CLOSING_ID_PATTERN = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi;

export const closingLink = (closingId) => `${CONTROL_PANEL_PATH}?id=${closingId}`;

export const isClosingCitationLink = (href) =>
  typeof href === "string" && href.startsWith(`${CONTROL_PANEL_PATH}?id=`);

export const linkifyClosingCitations = (text) => {
  if (typeof text !== "string" || text === "") return text;
  return text.replace(CLOSING_ID_PATTERN, (closingId) => `[${closingId}](${closingLink(closingId)})`);
};
